<!--
	lovi 新增银行卡
	2019-12-31
-->
<template>
  <div>
    <div class="bindCard-wrap">
      <Form
        ref="bankFormRef"
        :model="bankForm"
        :rules="bankRule"
        :label-width="120"
        label-position="right"
      >
        <FormItem :label="$t('bankCard.belonging') + '：'" prop="country">
          <Select
            v-model="bankForm.country"
            :placeholder="$t('bankCard.selectBelonging')"
          >
            <Option
              v-for="(item, index) in countryList"
              :value="item.country"
              :key="index"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="bankForm.country == 3"
          :label="$t('bankCard.accountName') + '：'"
          prop="name1"
        >
          <Input
            type="text"
            v-model="bankForm.name1"
            :placeholder="$t('bankCard.enterAccountName')"
          />
        </FormItem>
        <FormItem v-else :label="$t('bankCard.cardHolder') + '：'" prop="name">
          <Input
            type="text"
            v-model="bankForm.name"
            :placeholder="$t('bankCard.enterCardHolder')"
          />
        </FormItem>
        <FormItem
          v-if="bankForm.country == 3"
          :label="$t('bankCard.bankAccount') + '：'"
          prop="cardNumber1"
        >
          <Input
            v-model="bankForm.cardNumber1"
            :placeholder="$t('bankCard.enterAccountBank')"
          />
        </FormItem>
        <FormItem
          v-else
          :label="$t('bankCard.bankCardNumber') + '：'"
          prop="cardNumber"
        >
          <Input
            v-model="bankForm.cardNumber"
            :placeholder="$t('bankCard.enterBankNumber')"
          />
        </FormItem>
        <FormItem :label="$t('bankCard.openingBank') + '：'" prop="bankName">
          <Input
            v-model="bankForm.bankName"
            :placeholder="$t('bankCard.enterAccountBank')"
          />
        </FormItem>
        <FormItem
          :label="$t('bankCard.branch') + '：'"
          prop="bankBranch"
          v-if="bankForm.country == 3"
        >
          <Input
            v-model="bankForm.bankBranch"
            :placeholder="$t('bankCard.enterBranchAddress')"
          />
        </FormItem>
        <FormItem :label="$t('common.mobileNumber') + '：'" prop="phone">
          <Input
            type="number"
            v-model="bankForm.phone"
            :maxlength="11"
            :placeholder="$t('common.enterMobile')"
          />
        </FormItem>
      </Form>
      <div class="button-wrap">
        <Button type="primary" long @click="confirmFun" :loading="btnLoading">
          {{ editBankId ? $t("common.save") : $t("bankCard.confirmBinding") }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bindCardFlag: {
      type: Boolean,
      default: false
    },
    editBankId: {
      type: Number,
      default: 0
    }
  },
  data() {
    // 校验归属地
    const checkCountry = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("bankCard.selectBelonging")));
      } else {
        callback();
      }
    };
    // 校验姓名
    const checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("bankCard.enterCardHolder")));
      } else {
        callback();
      }
    };
    const checkName1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("bankCard.enterAccountName")));
      } else {
        callback();
      }
    };
    // 校验银行卡
    const checkCardNumber = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("bankCard.enterBankNumber")));
      } else {
        callback();
      }
    };
    const checkCardNumber1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("bankCard.enterAccountBank")));
      } else {
        callback();
      }
    };
    // 校验开户银行
    const checkBankName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("bankCard.enterAccountBank")));
      } else {
        callback();
      }
    };
    // 校验分行
    const checkBankBranch = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("bankCard.enterBranchAddress")));
      } else {
        callback();
      }
    };
    return {
      // 添加银行卡
      bankForm: {
        country: "",
        name: "",
        name1: "",
        cardNumber: "",
        cardNumber1: "",
        bankName: "",
        bankBranch: "",
        phone: ""
      },
      bankRule: {
        country: [
          {
            trigger: "change",
            required: true,
            validator: checkCountry
          }
        ],
        name: [
          {
            trigger: "blur",
            required: true,
            validator: checkName
          }
        ],
        name1: [
          {
            trigger: "blur",
            required: true,
            validator: checkName1
          }
        ],
        cardNumber: [
          {
            trigger: "blur",
            required: true,
            validator: checkCardNumber
          }
        ],
        cardNumber1: [
          {
            trigger: "blur",
            required: true,
            validator: checkCardNumber1
          }
        ],
        bankName: [
          {
            trigger: "blur",
            required: true,
            validator: checkBankName
          }
        ],
        bankBranch: [
          {
            trigger: "blur",
            required: true,
            validator: checkBankBranch
          }
        ]
      },
      countryList: [
        // 归属地
        { name: this.$t("bankCard.china"), country: 1 },
        { name: this.$t("bankCard.philippines"), country: 2 },
        { name: this.$t("bankCard.vietnam"), country: 3 }
      ],
      bankList: [], // 银行卡列表
      btnLoading: false // 按钮loadding
    };
  },
  created() {
    if (this.editBankId) {
      this._getBankCardById(this.editBankId);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    _getBankCardById(id) {
      // 获取编辑银行卡信息
      let vm = this;
      vm.$post("/app/bankcard/getBankCardById", { id: id }).then(res => {
        console.log(res, "getBankCardById");
        vm.bankForm.country = res.country;
        vm.bankForm.name = res.name;
        vm.bankForm.name1 = res.name;
        vm.bankForm.cardNumber = res.card_number;
        vm.bankForm.cardNumber1 = res.card_number;
        vm.bankForm.bankName = res.bank_name;
        vm.bankForm.bankBranch = res.bank_branch;
        vm.bankForm.phone = res.phone;
      });
    },
    confirmFun() {
      //添加银行卡表单验证
      let vm = this;
      vm.$refs.bankFormRef.validate().then(valid => {
        if (valid) {
          vm.bankParams(vm.bankForm);
        } else {
          vm.$Message.error(vm.$t("common.enterCorrectInformation"));
        }
      });
    },

    bankParams(data) {
      let vm = this;
      let params = {};
      params.country = data.country;
      params.name = data.country == 3 ? data.name1 : data.name;
      params.card_number =
        data.country == 3 ? data.cardNumber1 : data.cardNumber;
      params.bank_name = data.bankName;
      params.bank_branch = data.bankBranch;
      params.phone = data.phone;
      vm.btnLoading = true;
      if (vm.editBankId) {
        vm.editBankCard(params);
      } else {
        vm.addbankCard(params);
      }
    },
    addbankCard(params) {
      // 添加银行卡
      let vm = this;
      vm.$post("/app/bankcard/addbankCard", params, { alert: true }).then(
        res => {
          vm.btnLoading = false;
          console.log(res, "addbankCard");
          if (res.code == 0) {
            vm.$Message.success(res.msg);
            vm.$emit("update:bindCardFlag", false);
            vm.$emit("getBankCardList");
          } else {
            vm.$Message.error(res.msg);
          }
        }
      );
    },
    editBankCard(params) {
      // 编辑银行卡
      let vm = this;
      params.id = vm.editBankId;
      vm.$post("/app/bankcard/editbankcard", params, { alert: true }).then(
        res => {
          vm.btnLoading = false;
          console.log(res, "editBankCard");
          if (res.code == 0) {
            vm.$Message.success(res.msg);
            vm.$emit("update:bindCardFlag", false);
            vm.$emit("getBankCardList");
          } else {
            vm.$Message.error(res.msg);
          }
        }
      );
    }
  },
  watch: {},
  components: {},
  deactivated() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.bindCard-wrap {
  padding: 50px 200px;
  /deep/.ivu-form {
    .ivu-form-item-label {
      line-height: 20px;
      font-size: 16px;
    }
    .ivu-form-item-content {
      .ivu-input,
      .ivu-select-selection {
        height: 40px;
      }
      .ivu-select-placeholder,
      .ivu-select-selected-value {
        padding-top: 5px;
        padding-bottom: 5px;
        height: 40px;
        font-size: 14px;
      }
      .ivu-select-item {
        line-height: 20px;
      }
      .ivu-input-icon {
        width: 40px;
        height: 40px;
        line-height: 40px;
      }
      .ivu-input-number {
        width: 100%;
        height: 40px;
      }
      .ivu-input-number-input-wrap {
        height: 40px;
      }
      .ivu-input-number-handler {
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .ivu-input-number-input {
        height: 38px;
        line-height: 38px;
      }
    }
    .ivu-form-item-validating .ivu-input-icon + .ivu-input {
      padding-right: 40px;
    }
    .ivu-btn-primary {
      width: 250px;
      height: 45px;
      font-size: 20px;
    }
  }
}
</style>
